/* SLIDE 14 */
/* SLIDE 15 */

import React, { useState, useEffect, useRef, useReducer } from "react";
import ButtonBot from "shared/components/ButtonBot";
import AppInfoRow from "shared/components/AppInfoRow";
import Popup from "shared/components/Popup";
import cameraIcon from "assets/icons/cameraIcon.svg";
import { numberFormat, makeCenterLine, makeFixedLine, maskCardNumber, formatMinutesToTime } from "utils/common";
import AppSelectCustom from "shared/components/AppSelectCustom";
import AppSelect from "shared/components/AppSelect";
import closeIcon from 'assets/icons/close.svg';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { checkFee, checkFeeOutTime, getParkingTid } from "features/parking/usecases/CarInOutUsecases";
import { recognition, updateSpaceUse, onPaymentFee, getDiscountList, applyOrCancelDiscountOutTime, setUnpaidCustom, uploadDiscountImage, carImageSub, carImageSubUpload, carImageSubDelete } from "features/parking/usecases/CarInOutUsecases";
import { ThreeDots } from 'react-loader-spinner';
import checkIcon from "assets/icons/checkIcon.svg";
import cardIcon from "assets/icons/cardIcon.svg";
import SubHeader from "shared/components/SubHeader";
import Skeleton from 'react-loading-skeleton';
import { setAppLoading, setShowBack } from "../../../shared/store/headerSlice";
import note2Icon from "assets/icons/note2Icon.svg";
import InputMask from "react-input-mask";
import { setShowHeader } from "shared/store/headerSlice";
import captureClose from "assets/icons/captureClose.svg";
import captureIcon from "assets/icons/captureIcon.svg";
import { toast } from "react-toastify";
import removeDiscountIcon from "assets/icons/removeDiscountIcon.svg";
import { datetimeFormat, getFormattedTime, isDuplicateEntryIdAtIndex, replaceImageLink } from "../../../utils/common";
import { DateTime } from "luxon";
import { onGetParkingTid } from "../utils/parkingUtils";
import { captureImage, handleImageError, startCamera, stopCamera } from "../utils/cameraUtils";
import api, { getApiBaseUrl } from "../../../helpers/api";
import { set } from "react-hook-form";
import { setUser, setDayType, setServerTime } from "../../auth/presentation/store/authSlice";
import { getParkingOperateTime } from "../usecases/CarInOutUsecases";
import { getServerTime } from "features/auth/usecases/AuthUsecases";
import AppInfiniteScroll from "../../../shared/components/AppInfiniteScroll";
import ImageViewPopup from "../../../shared/components/ImageViewPopup";
import plusIcon from "assets/icons/plusIcon.svg";

// Manage State popup with usereducer
const initialPopupState = {
  showPopupDiscount: false,
  showPopupPay: false,
  showPopupPayError: false,
  showPopupError: false,
  showPopupErrorTime: false,
  showPopupCompareTime: false,
  showPopupNice: false,
  showPopupRemoveDiscount: false,
  showPopupFeeAlert: false,
  showPopupMissingTid: false,
  showPopupParkingOperateTime: false,
  showPopupTurnOut: false,
  showPopupZeroFee: false,
  showPopupUnpaid: false,
  showPopupRemoveAllDiscount: false,
};

const popupReducer = (state, action) => {
  switch (action.type) {
    case 'SET_POPUP':
      return { ...state, [action.payload.key]: action.payload.value };
    case 'RESET':
      return initialPopupState;
    default:
      return state;
  }
};



const ParkingPayment = () => {
  // Utility to generate hour and minute options
  //const generateHours = () => Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  //const generateMinutes = () => Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
  const [generateHours, setGenerateHours] = useState([]);
  const [generateMinutes, setGenerateMinutes] = useState([]);

  const { selectedSpot, parkingSpots } = useSelector((state) => state.parking);
  const { user, serverTime, dayType } = useSelector((state) => state.auth);
  const { appLoading } = useSelector((state) => state.header);

  const [popupState, dispatchPopup] = useReducer(popupReducer, initialPopupState);

  const [checkOutData, setCheckOutData] = useState({});
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [discountList, setDiscountList] = useState([]);
  const [loadingPayment, setLoadingPayment] = useState(false);
  const [completePayment, setCompletePayment] = useState(false);
  const [unpaidPayment, setUnpaidPayment] = useState(false);
  const [payData, setPayData] = useState({});
  const [pageLoading, setPageLoading] = useState(1);
  const [checkOutTime, setCheckOutTime] = useState("");
  const [outHour, setOutHour] = useState("");
  const [outMinute, setOutMinute] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState("");
  const [selectedDiscountRemove, setSelectedDiscountRemove] = useState("");
  const [isOpenCamera, setIsOpenCamera] = useState(false);
  const [isOpenCameraCustom, setIsOpenCameraCustom] = useState(false);
  const [discountImage, setDiscountImage] = useState(null);
  const [discountImageRemove, setDiscountImageRemove] = useState(null);
  const [parkingTid, setParkingTid] = useState(null);
  const [showErrorImg, setShowErrorImg] = useState(false)
  const [loadFirst, setLoadFirst] = useState(true);
  const [isPopupFullImageOpen, setIsPopupImageFullOpen] = useState(false);
  const [isPopupFullCustomImageOpen, setIsPopupCustomImageFullOpen] = useState(false);
  const [customImage, setCustomImage] = useState({
    image1: null,
    image2: null
  })
  const [zoomLevel, setZoomLevel] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const discountRef = useRef(null);
  const paymentRef = useRef(false);
  const customImageOrderRef = useRef(1);
  const customImageRemoveRef = useRef(1);
  const imageCaptureTypeRef = useRef("DISCOUNT");

  const hasInitializedCheckoutTime = useRef(false);

  //console.log("Selected Spot:", selectedSpot);

  useEffect(() => {
    if (unpaidPayment || completePayment) {
      dispatch(setShowBack(false));
    }
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, [unpaidPayment, completePayment]);

  useEffect(() => {
    if (discountImage) {
      setShowErrorImg(false);
    }
  }, [discountImage]);

  useEffect(() => {
    if (isOpenCamera || isOpenCameraCustom) startCamera({
      videoRef: videoRef,
      setShowHeader: (value) => dispatch(setShowHeader(value)),
    });
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach(track => track.stop());
      }
    };
  }, [isOpenCamera, isOpenCameraCustom]);

  const fetchCheckOutFee = async (newHour, newMinute) => {
    await new Promise(async (resolve, reject) => {
      hasInitializedCheckoutTime.current = true;
      pageLoading > 1 && dispatch(setAppLoading(true));
      if (!(serverTime instanceof DateTime)) {
        hasInitializedCheckoutTime.current = false;
        return;
      };
      try {


        const extraSpace = isDuplicateEntryIdAtIndex(parkingSpots, parseInt(selectedSpot?.spaceNumber) - 1)

        //handle inTime entries
        let inTimeDay = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("dd");
        let inTimeMonth = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("MM");
        let inTimeYear = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("yyyy");

        const response = await checkFeeOutTime({
          parkingId: user.parkingId,
          carNumber: selectedSpot.carNum,
          facilityId: selectedSpot?.spaceNumber?.toString().padStart(5, "0") || "00001",
          outTime: serverTime?.set({
            year: inTimeYear,
            month: inTimeMonth,
            day: inTimeDay,
            hour: newHour || outHour,
            minute: newMinute || outMinute,
            second: 0
          }).toISO(),
          extraSpace: extraSpace
        });
        discountRef.current = response?.fee?.discountDetails[0]?.id || null;
        setSelectedDiscount(response?.fee?.discountDetails[0]?.id || "");
        setCheckOutData(response);
        setPaymentAmount(response?.fee?.feeFinal);

      } catch (error) {
        console.error("Error fetching checkout fee:", error);
        reject(error);
      } finally {
        setPageLoading(prev => prev + 1);
        dispatch(setAppLoading(false));
        hasInitializedCheckoutTime.current = false;
        resolve();
      }
    })

  };

  const fetchCarImageSub = async () => {
    try {
      const response = await carImageSub({
        parkingId: user.parkingId,
        entryId: selectedSpot.entryId
      });
      response?.carImageList?.map((value, index) => {
        if (value?.carImage?.includes("_1.")) {
          setCustomImage(prev => {
            return {
              ...prev,
              image1: replaceImageLink(value?.carImage),
              imageOrigin1: value?.carImage
            }
          })
        } else {
          setCustomImage(prev => {
            return {
              ...prev,
              image2: replaceImageLink(value?.carImage),
              imageOrigin2: value?.carImage
            }
          })
        }
      })


    } catch (error) {
      console.error("Error fetching discount list:", error);
    }

  }

  const fetchDiscountList = async () => {
    await new Promise(async (resolve, reject) => {
      try {
        const response = await getDiscountList({
          parkingId: user.parkingId
        });

        let discountList = response?.discountList.map((item) => ({
          label: `${item.discountName} (${item.value}${item.discountCategoryCd == "FEE" ? "원" : (item.discountCategoryCd == "PERCENTAGE" ? "%" : "분")})`,
          value: item.discountId,
          discountId: item.discountId,
          discountCategoryCd: item.discountCategoryCd,
          ranking: item.ranking,
          // discountId: item.discountId,
        }));
        discountList?.unshift({
          label: "할인 옵션 선택",
          value: "",
        });

        setDiscountList(discountList);
        resolve();

      } catch (error) {
        console.error("Error fetching discount list:", error);
        reject(error);
      }
    });
  };

  const checkTimePage = async () => {
    await new Promise(async (resolve, reject) => {
      try {

        const getServerTimeApi = await getServerTime({
          dateTime: selectedSpot.inTime
        });

        const serverTime = DateTime.fromISO(
          getServerTimeApi?.ISO || DateTime.now().setZone('Asia/Seoul').toISO(),
          { setZone: true }
        );

        setOutHour(getFormattedTime(serverTime, "HH"));
        setOutMinute(getFormattedTime(serverTime, "mm"));

        dispatch(setServerTime(serverTime.isValid ? serverTime : DateTime.now().setZone('Asia/Seoul')));
        dispatch(setDayType(getServerTimeApi?.dayType || 'WEEKDAY'));

        resolve();

      } catch (error) {
        console.error('Error checking time:', error);
        reject(error);
      }
    });
  };

  const generateHoursChange = (start, end) => {
    const from = parseInt(start);
    const to = parseInt(end);
    return Array.from({ length: to - from + 1 }, (_, i) =>
      (from + i).toString().padStart(2, '0')
    );
  };

  const refreshFunction = () => {
    setLoadFirst(true);
    setPageLoading(1);
    onEnterPage();
  }

  const onEnterPage = async () => {
    await checkParkingOperateTime();
    await checkTimePage();
    await fetchDiscountList();
    await fetchCarImageSub();
    setLoadFirst(false);
  }

  useEffect(() => {
    onEnterPage();
    return () => {
      hasInitializedCheckoutTime.current = false;
      setPageLoading(1);
    };
  }, []);

  const validateTime = (hour, minute, workingBeginHour, workingBeginMinute, workingEndHour, workingEndMinute) => {

    if (!hour || !minute) return false;
    if (hour < workingBeginHour || hour > workingEndHour) return false;
    if (hour == workingBeginHour && minute < workingBeginMinute) return false;
    if (hour == workingEndHour && minute > workingEndMinute) return false;

    return true;
  };

  const firstLoading = async () => {
    let weekdayHours = user?.parking?.weekdayOperatingHours;

    if (dayType == 'WEEKEND' && user?.parking?.weekendOperatingHours) {
      weekdayHours = user?.parking?.weekendOperatingHours;
    } else if (dayType == 'HOLIDAY' && user?.parking?.holidayOperatingHours) {
      weekdayHours = user?.parking?.holidayOperatingHours;
    }

    if (!weekdayHours) return;

    const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
    const [workingBeginHour, workingBeginMinute] = beginStr.split(":");
    const [workingEndHour, workingEndMinute] = endStr.split(":");

    const hourOptions = generateHoursChange(workingBeginHour, workingEndHour);
    setGenerateHours(hourOptions);

    let minuteOptions = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, "0"));
    if (outHour === workingBeginHour) {

      minuteOptions = Array.from({ length: 60 - parseInt(workingBeginMinute) }, (_, i) =>
        (parseInt(workingBeginMinute) + i).toString().padStart(2, "0")
      );
      if (outMinute < workingBeginMinute) {
        setOutMinute(workingBeginMinute);
      }

    } else if (outHour === workingEndHour) {

      minuteOptions = Array.from({ length: parseInt(workingEndMinute) + 1 }, (_, i) =>
        i.toString().padStart(2, "0")
      );
      if (outMinute > workingEndMinute) {
        setOutMinute(workingEndMinute);
      }

    } else if (outHour < workingBeginHour) {

      setOutHour(workingBeginHour);
      setOutMinute(workingBeginMinute);

    } else if (outHour > workingEndHour) {

      setOutHour(workingEndHour);
      setOutMinute(workingEndMinute);

    } else {
      setOutHour(loadFirst ? getFormattedTime(serverTime, "HH") : outHour);
      setOutMinute(loadFirst ? getFormattedTime(serverTime, "mm") : outMinute);
    }

    setGenerateMinutes(minuteOptions);
    !hasInitializedCheckoutTime.current && !loadFirst && !paymentRef.current && validateTime(outHour, outMinute, workingBeginHour, workingBeginMinute, workingEndHour, workingEndMinute) && fetchCheckOutFee();

  }

  useEffect(() => {
    if (!outHour) return;
    if (!outMinute) return;
    firstLoading();
  }, [outHour, outMinute, user, loadFirst]);

  const handlePaymentResponse = (event) => {
    const msg = JSON.parse(event.data);
    // alert(JSON.stringify(msg));
    try {
      if (msg.type === 'payRes') {
        if (['0000', '0021'].includes(msg.body.responseCode)) {
          setPayData(msg.body);
          onPaymentSuccess(msg.body, 'PAY');

        } else {
          setLoadingPayment(false);
          dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: true } });
        }
      } else if (msg.type === 'printRes') {
        if (['0000', '0021'].includes(msg.body.responseCode)) {
          // when print success
        }
      } else if (msg.type === 'imageSelected') {
        onUploadCarImageSub(msg);
      } else if (msg.type === 'notInstalled') {
        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: true } });
        setLoadingPayment(false);
      }
    } catch (e) {
      console.error('Fail to parse message:', e);
    }
  };

  useEffect(() => {
    // window.addEventListener('message', responseHandler);
    document.addEventListener('message', handlePaymentResponse);
    return () => document.removeEventListener('message', handlePaymentResponse);
  }, [paymentAmount, checkOutTime, parkingTid]);

  const onFreeFee = async (receipt = false) => {

    dispatchPopup({ type: 'RESET' });
    setLoadingPayment(true);

    paymentRef.current = true;
    const isValidTime = await checkParkingOperateTime();
    if (!isValidTime) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupParkingOperateTime', value: true } });
      setTimeout(() => {
        paymentRef.current = false;
      }, 0);
      return;
    }


    onPaymentSuccess(null, receipt ? 'OUT' : null);
  }

  const onPaymentSuccess = async (payRes, type = null) => {

    // dispatchPopup({ type: 'RESET' });
    // setLoadingPayment(true);

    // paymentRef.current = true;
    // const isValidTime = await checkParkingOperateTime();
    // if (!isValidTime) {
    //   dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupParkingOperateTime', value: true } });
    //   setTimeout(() => {
    //     paymentRef.current = false;
    //   }, 0);
    //   return;
    // }


    try {
      // let inDate = new Date(serverTime?.IOSTime).toISOString();
      // const checkoutDate = new Date(checkOutTime.replace(' ', 'T') + ':00');
      // if (!isNaN(checkoutDate.getTime())) {
      //   inDate = checkoutDate.toISOString();
      //   console.log('inDate', inDate);
      // }

      //handle inTime entries
      let inTimeDay = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("dd");
      let inTimeMonth = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("MM");
      let inTimeYear = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("yyyy");

      const inDate = serverTime?.set({
        year: inTimeYear,
        month: inTimeMonth,
        day: inTimeDay,
        hour: outHour,
        minute: outMinute,
        second: 0,
      }).toISO();

      const data = {
        parkingId: user.parkingId,
        facilityId: selectedSpot?.spaceNumber?.toString().padStart(5, "0") || "00001",
        facilityKind: "LPR_OUT",
        angle: "MAIN",
        recognitionId: "11",
        carNumber: selectedSpot.carNum,
        dateTime: inDate,
        payStationId: "MOBILE",
        userId: user.userId,
      }

      console.log("Payment Data:", data);
      const payTime = DateTime.fromFormat(`20${payRes?.authDate}`, "yyMMddHHmmss");

      const price = paymentAmount || 0;
      const payment = await onPaymentFee({
        ...data,
        payWay: price == 0 ? "CASH" : "CRDCRD",
        payStationId: user.userId,
        price: paymentAmount || 0,
        payTime: payTime?.isValid ? payTime.toISO() : getFormattedTime(serverTime, "ISO"),
        entryList: [
          {
            payType: "PARKING_FEE",
            parkingEntryId: "",
            membershipApplicantId: "",   // 정기권ID
            extendedMonths: 0,           // 정기권 연장 달수
          }
        ],

        cardNumber: maskCardNumber(payRes?.track2Data),
        approvalNumber: payRes?.authNo,
        buyerCode: payRes?.buyerCode,
        buyerName: payRes?.buyerCompany,
        issuerCode: payRes?.issuerCode,
        issuerName: payRes?.issuerCompany,
        storeNumber: payRes?.storeNo,
        terminalId: parkingTid || "1004930001",
        cardReadData: payRes?.payUniqueNo,

      });
      await recognition(data);
      if (payment.gate == "OPEN") {
        setCompletePayment(true);
        await updateSpaceUse({
          ...data,
          entryId: selectedSpot?.entryId,
          spaceNumbers: [selectedSpot.spaceNumber],
        });
      } else {
        setCompletePayment(true);
        await updateSpaceUse({
          ...data,
          entryId: selectedSpot?.entryId,
          spaceNumbers: [selectedSpot.spaceNumber],
        });
      }
      if (type) {
        onBillPrint(payRes, type);
      }

    } catch (error) {
      console.error("Error during payment success:", error);
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: true } });
    } finally {
      setLoadingPayment(false);
    }
  }

  const checkParkingOperateTime = async () => {
    const response = await getParkingOperateTime({
      parkingId: user.parkingId,
    });
    let weekdayHours = response?.weekdayOperatingHours;

    if (dayType == 'WEEKEND' && response?.weekendOperatingHours) {
      weekdayHours = response?.weekendOperatingHours;
    } else if (dayType == 'HOLIDAY' && response?.holidayOperatingHours) {
      weekdayHours = response?.holidayOperatingHours;
    }

    if (!weekdayHours) return;

    dispatch(setUser({
      ...user,
      parking: {
        ...user.parking,
        weekdayOperatingHours: response?.weekdayOperatingHours,
        weekendOperatingHours: response?.weekendOperatingHours,
        holidayOperatingHours: response?.holidayOperatingHours,
      }
    }))

    const [beginStr, endStr] = weekdayHours.split("~").map(t => t.trim());
    const [workingBeginHour, workingBeginMinute] = beginStr.split(":");
    const [workingEndHour, workingEndMinute] = endStr.split(":");

    if (outHour < workingBeginHour || outHour > workingEndHour || outHour == workingBeginHour && outMinute < workingBeginMinute || outHour == workingEndHour && outMinute > workingEndMinute) {
      dispatchPopup({ type: 'RESET' });

      return false;
    } else {
      return true;
    }

  }

  const onPayment = async () => {

    try {

      if (paymentAmount <= 0) {
        dispatch(setAppLoading(true));
        await onPaymentSuccess();
        dispatch(setAppLoading(false));
        return false;
      }

      dispatchPopup({ type: 'RESET' });
      setLoadingPayment(true);

      paymentRef.current = true;
      const isValidTime = await checkParkingOperateTime();
      if (!isValidTime) {
        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupParkingOperateTime', value: true } });
        setTimeout(() => {
          paymentRef.current = false;
        }, 0);
        return;
      }

      const extraSpace = isDuplicateEntryIdAtIndex(parkingSpots, parseInt(selectedSpot?.spaceNumber) - 1);

      const payKey = await onGetParkingTid(user.parkingId, selectedSpot.entryId);

      if (!payKey || !payKey.tid) {
        setLoadingPayment(false);
        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: true } });
        return;
      } else {
        setParkingTid(payKey.tid);
      }

      // const response = await checkFeeOutTime({
      //   parkingId: user.parkingId,
      //   carNumber: selectedSpot.carNum,
      //   facilityId: "00003",
      //   outTime: getFormattedTime(serverTime, "ISO"),
      //   extraSpace: extraSpace
      // });

      // payment params
      const params = new URLSearchParams({
        billType: '0',                      // 전문종류 ( 0:신용 )
        terminalNo: payKey?.tid,            // 단말기 번호
        orderKey: '99999',                  // 주문번호 ( 요청/응답 명시 용도 )
        authType: '0',                      // 0: 승인, 1: 취소
        installment: '00',                  // 할부 개월 ( 00:일시불 )
        amount: paymentAmount || '0',       // 거래금액 ( 부가세, 봉사료 제외 금액 )
        tax: '0',                           // 세금 (부가세 없음)
        tip: '0',                           // 봉사료(없음)
        isSign: 'D',                        // 서명처리 ( ‘Y’:사용, ‘N’:미사용, ‘D’: NICEPAY 앱 판단 )
        resScheme: 'innodep://payResponse', // 응답 스키마

      });

      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "payReq", body: params.toString() })
        );
      } else {
        setLoadingPayment(false);
        console.error('Cannot find Native App !!');
      }

      // pay request End
    } catch (error) {
      console.error("Error during payment:", error);
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: true } });
    }


  }

  const onReceiptPrint = async () => {
    dispatch(setAppLoading(true));

    try {

      const form = `
${makeCenterLine('[입차증]')}
================================================
${makeFixedLine('구획번호:', selectedSpot.spaceNumber)} 
${makeFixedLine('차량번호:', checkOutData?.fee?.carNumber)}
${makeFixedLine('관리자번호:', user?.mobilePhone)}
${makeFixedLine('입차시간:', DateTime.fromISO(checkOutData?.fee?.inTime).toFormat("yyyy-MM-dd HH:mm"))}
${makeFixedLine('주차장소:', user?.parking?.parkingName)}
${makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')}
${makeFixedLine('주차문의:', user?.parking?.phoneNumber)}
================================================
${makeCenterLine('근무자 휴식시간 안내')}
* 현장근무자 휴식시간 및 전화가 꺼져있는 경우 하단 관리자번호로 차량번호 필수 작성 후 문자 보내주세요. 주차요금 계좌번호 등 문자 전송해 드립니다.
================================================
${makeCenterLine('미납요금 납부방법')}
송파구시설관리공단 공영주차부 홈페이지 
(www.songpagongdanpark2.or.kr) 미납요금 조회 및 요금을 납부하실 수 있습니다.
================================================
${makeCenterLine('결제문의')}
주차관리자 관리자 번호 전화기가 꺼져있을경우 문자 남겨주세요.
================================================
${makeCenterLine('송파구시설관리공단')}
`;
      // print params for VAN API
      const params = new URLSearchParams({
        billType: '9',                        // 전문종류 ( 9:프린터출력 )
        terminalNo: '1004930001',             // 단말기 번호 ( 테스트 TID : 1004930001 )
        orderKey: '99999',                    // 주문번호 ( 요청/응답 명시 용도 )
        printResType: '1',
        resScheme: 'innodep://printResponse', // 응답 스키마 ( ex. nicepos://response... )
      });

      if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: "print", body: params.toString(), printForm: form })
        );
      } else {
        setLoadingPayment(false);
        console.error('Cannot find Native App !!');
      }
    } catch (error) {
      console.error('Error parsing WebView message:', error);
    } finally {
      dispatch(setAppLoading(false));
    }


  }

  const onBillPrint = async (payRes, type = 'PAY') => {

    let title = '';

    switch (type) {
      case 'PAY':
        title = '매출전표';
        break;
      case 'OUT':
        title = '출차증';
        break;
      case 'UNPAID':
        title = '미납증';
        break;

      default:
        title = '매출전표';
        break;
    }

    const encoder = new TextEncoder(); // 기본 utf-8

    let form = [
      0x0A,
      0x1B, 0x40, //명령 초기화

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode(makeCenterLine(title, true)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화

      0x1B, 0x61, 0x02,   // 우측 정렬
      ...encoder.encode('No:' + (window.APP_CONFIG?.parkingSeq || '000010')), 0x0A,
      0x1B, 0x61, 0x00,   // 왼쪽 정렬

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('주차장명:', user?.parking?.parkingName)), 0x0A,
      ...encoder.encode(makeFixedLine('사업자주소:', user?.parking?.address)), 0x0A,
      ...encoder.encode(makeFixedLine('전화번호:', user?.parking?.phoneNumber)), 0x0A,
      ...encoder.encode(makeFixedLine('일시:', getFormattedTime(serverTime, "yyyy-MM-dd HH:mm:ss"))), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

      ...encoder.encode(makeFixedLine('차량번호:', checkOutData?.fee?.carNumber)), 0x0A,
      ...encoder.encode(makeFixedLine('입차일시:', datetimeFormat(checkOutData?.fee?.inTime, "ISO", "yyyy-MM-dd HH:mm"))), 0x0A,
      ...encoder.encode(makeFixedLine('출차일시:', datetimeFormat(checkOutData?.fee?.outTime, "ISO", "yyyy-MM-dd HH:mm"))), 0x0A,
      ...encoder.encode(makeFixedLine('주차시간:', formatMinutesToTime(checkOutData?.fee?.parkingMinute))), 0x0A,
      ...encoder.encode(makeFixedLine('주차요금:', numberFormat(checkOutData?.fee?.feeCalculated))), 0x0A,
    ];

    if (Array.isArray(checkOutData?.fee?.discountDetails)) {
      checkOutData?.fee?.discountDetails.forEach((discount, idx) => {
        form.push(
          ...encoder.encode(makeFixedLine(idx === 0 ? '할인항목:' : '', discount.name)), 0x0A,
        );
      });
    }

    form.push(

      ...encoder.encode(makeFixedLine('할인금액:', '-' + numberFormat(checkOutData?.fee?.feeDiscount))), 0x0A,
      ...encoder.encode(makeFixedLine('정산금액:', numberFormat(paymentAmount))), 0x0A,

      0x1D, 0x21, 0x11,   // 크기 크게
      ...encoder.encode('-'.repeat(24)), 0x0A,
      0x1D, 0x21, 0x00,   // 크기 초기화
      0x0A,

    );

    if (type === 'PAY' && payRes) {
      form.push(
        ...encoder.encode(makeFixedLine('카드번호:', maskCardNumber(payRes?.track2Data))), 0x0A,
        ...encoder.encode(makeFixedLine('승인번호:', payRes?.authNo)), 0x0A,
        ...encoder.encode(makeFixedLine('카드사명:', payRes?.issuerCompany)), 0x0A,
        ...encoder.encode(makeFixedLine('매입사명:', payRes?.buyerCompany)), 0x0A,

        0x1D, 0x21, 0x11,   // 크기 크게
        ...encoder.encode('-'.repeat(24)), 0x0A,
        0x1D, 0x21, 0x00,   // 크기 초기화
        0x0A,
      );
    }

    form.push(
      ...encoder.encode(makeCenterLine('이용해 주셔서 감사합니다.')), 0x0A
    );

    const formData = new Uint8Array(form);

    const formEnc = btoa(String.fromCharCode(...formData));

    const payKey = await onGetParkingTid(user.parkingId, selectedSpot.entryId);

    if (!payKey || !payKey.tid) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: true } });
      return;
    }

    // print params for VAN API
    const params = new URLSearchParams({
      billType: '9',                        // 전문종류 ( 9:프린터출력 )
      terminalNo: payKey?.tid,              // 단말기 번호
      orderKey: '99999',                    // 주문번호 ( 요청/응답 명시 용도 )
      printResType: '1',
      resScheme: 'innodep://printResponse', // 응답 스키마
    });

    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "print", body: params.toString(), printForm: formEnc })
      );
    } else {
      // setLoadingPayment(false);
      console.error('Cannot find Native App !!');
    }
  }

  const onCancelAllDiscount = async (type) => {
    dispatchPopup({ type: 'RESET' });
    dispatch(setAppLoading(true));
    try {
      const extraSpace = isDuplicateEntryIdAtIndex(parkingSpots, parseInt(selectedSpot?.spaceNumber) - 1)
      for (const item of checkOutData?.fee?.discountDetails || []) {
        let response = await applyOrCancelDiscountOutTime({
          parkingId: user.parkingId,
          carNumber: selectedSpot.carNum,
          userId: user.userId,
          discountFlag: "CANCEL",
          discountId: item?.id,
          outTime: serverTime?.set({
            hour: outHour,
            minute: outMinute,
            second: 0
          }).toISO(),
        });

        if (response.status == 200) {
          setCheckOutData(current => ({
            ...current,
            fee: {
              ...response,
            }
          }));
          setPaymentAmount(response?.feeFinal);

        } else {
          throw new Error("Failed to cancel discount");
        }

      }

      setSelectedDiscount("");
      setDiscountImageRemove(null);
      discountRef.current = type == "CANCEL" ? null : selectedDiscount;
      setDiscountImage(null);
      setSelectedDiscountRemove("");

      toast.success('성공했습니다.', {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: 'htToastSuccess',
      });

    } catch (error) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: true } });
      console.error("Error during discount application:", error);
    } finally {
      dispatch(setAppLoading(false));
    }
  }

  function isIdInArray(array, idToCheck) {
    return array.some(item => item.id === idToCheck);
  }

  const onApplyOrCancelDiscount = async (type, id) => {
    console.log(id);
    let imageArrShow = ['12', '13', '14', '15', '18', '19', '21', '22', '23', '24', '26', '27', '29', '30']
    let multipleDiscount = ['10', '30']

    if (type == "APPLY") {
      if (imageArrShow.includes(id)) {
        if (discountImage == null) {
          setShowErrorImg(true)
          return false;
        }
      }
    }

    let currentDiscount = checkOutData?.fee?.discountDetails || [];

    if (multipleDiscount.includes(id) && isIdInArray(currentDiscount, id) && type == "APPLY") {
      return false;
    }

    dispatchPopup({ type: 'RESET' });
    dispatch(setAppLoading(true));
    try {
      const extraSpace = isDuplicateEntryIdAtIndex(parkingSpots, parseInt(selectedSpot?.spaceNumber) - 1)
      if (type == "APPLY" && !multipleDiscount.includes(id)) {


        for (const item of checkOutData?.fee?.discountDetails || []) {
          !multipleDiscount.includes(item?.id) && await applyOrCancelDiscountOutTime({
            parkingId: user.parkingId,
            carNumber: selectedSpot.carNum,
            userId: user.userId,
            discountFlag: "CANCEL",
            discountId: item?.id,
            outTime: serverTime?.set({
              hour: outHour,
              minute: outMinute,
              second: 0
            }).toISO(),
          });

        }

      }

      const response = await applyOrCancelDiscountOutTime({
        parkingId: user.parkingId,
        carNumber: selectedSpot.carNum,
        userId: user.userId,
        discountFlag: type,
        discountId: id,
        outTime: serverTime?.set({
          hour: outHour,
          minute: outMinute,
          second: 0
        }).toISO(),
        extraSpace: extraSpace
      });

      if (imageArrShow.includes(selectedDiscount)) {
        type == "APPLY" && discountImage && await uploadDiscountImage({
          parkingId: user.parkingId,
          entryId: selectedSpot.entryId,
          discountId: selectedDiscount,
          discountApplyId: response?.discountApplyId,
          image: discountImage,
        })
      }

      if (response.status == 200) {
        discountRef.current = type == "CANCEL" ? null : selectedDiscount,
          setDiscountImage(null);
        setSelectedDiscountRemove("");
        if (type == "CANCEL") {
          setSelectedDiscount(response?.discountDetails?.[response?.discountDetails?.length - 1]?.id || "");
          setDiscountImageRemove(null);
        }
        setCheckOutData(current => ({
          ...current,
          fee: {
            ...response,
          }
        }));
        setPaymentAmount(response?.feeFinal);
        // setSelectedDiscount('');
        toast.success('성공했습니다.', {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          className: 'htToastSuccess',
        });
      } else {
        throw new Error("Failed to apply discount");
      }

      // console.log("CheckOut Fee Response:", response);



    } catch (error) {
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: true } });
      console.error("Error during discount application:", error);
    } finally {
      dispatch(setAppLoading(false));
    }
  }

  const onUnpaid = async (receipt = false) => {

    try {

      dispatchPopup({ type: 'RESET' });
      dispatch(setAppLoading(true));

      paymentRef.current = true;
      const isValidTime = await checkParkingOperateTime();
      if (!isValidTime) {
        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupParkingOperateTime', value: true } });
        setTimeout(() => {
          paymentRef.current = false;
        }, 0);
        return;
      }

      //handle inTime entries
      let inTimeDay = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("dd");
      let inTimeMonth = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("MM");
      let inTimeYear = DateTime.fromFormat(selectedSpot.inTime, "yyyyMMddHHmmss").toFormat("yyyy");

      const response = await setUnpaidCustom({
        parkingId: user.parkingId,
        facilityId: selectedSpot?.spaceNumber?.toString().padStart(5, "0") || "00001",
        carNumber: selectedSpot.carNum,
        dateTime: getFormattedTime(serverTime, "ISO"),
        outTime: serverTime?.set({
          year: inTimeYear,
          month: inTimeMonth,
          day: inTimeDay,
          hour: outHour,
          minute: outMinute,
          second: 0
        }).toISO(),
        feeCustom: checkOutData?.fee?.feeFinal,
      });
      if (response.status == 200) {
        setCheckOutTime(response?.outTime);
        setCheckOutData(prev => ({
          ...prev,
          fee: {
            ...prev.fee,
            ...response,
          }
        }));
        setUnpaidPayment(true);
        if (receipt) {
          onBillPrint(null, 'UNPAID')
        }
      }
      // navigate("/parking_payment_pending");

    } catch (error) {
      console.error("Error during unpaid:", error);
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: true } });
    } finally {
      dispatch(setAppLoading(false));
    }
  }

  const onSelectImage = (num) => {
    customImageOrderRef.current = num;
    if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "selectImage" })
      );
    } else {
      // setLoadingPayment(false);
      console.error('Cannot find Native App !!');
    }
  }

  const onUploadCarImageSub = async (msg) => {
    const carImage = `data:image/jpeg;base64,${msg.base64}`
    try {
      dispatch(setAppLoading(true));
      if (customImageOrderRef.current == 1) {
        setCustomImage(prev => {
          return {
            ...prev,
            image1: carImage
          }

        })
      } else if (customImageOrderRef.current == 2) {
        setCustomImage(prev => {
          return {
            ...prev,
            image2: carImage
          }

        })
      }
      const response = await carImageSubUpload({
        parkingId: user?.parking?.parkingId,
        entryId: selectedSpot.entryId,
        carImage: carImage,
        seq: customImageOrderRef.current,
      })
      dispatch(setAppLoading(false));
      fetchCarImageSub();
      toast.success('성공했습니다.', {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: 'htToastSuccess',
      });
    } catch (error) {
      dispatch(setAppLoading(false));
      console.log(error)
    }
  }

  const handleRemoveCarImageSub = async () => {
    try {
      dispatch(setAppLoading(true));
      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveCustomImage', value: false } });
      let carImage = null;
      if (customImageRemoveRef.current == 1) {
        const parts = customImage?.imageOrigin1?.split("/");
        const lastPart = parts[parts.length - 1];
        carImage = lastPart;
        setCustomImage(prev => {
          return {
            ...prev,
            image1: null,
            imageOrigin1: null,
          }
        })
      } else if (customImageRemoveRef.current == 2) {
        const parts = customImage?.imageOrigin2?.split("/");
        const lastPart = parts[parts.length - 1];
        carImage = lastPart;
        setCustomImage(prev => {
          return {
            ...prev,
            image2: null,
            imageOrigin2: null
          }
        })
      }

      const res = await carImageSubDelete({
        carImage: carImage
      });
      dispatch(setAppLoading(false));
      fetchCarImageSub();
      toast.success('성공했습니다.', {
        position: "top-center",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: 'htToastSuccess',
      });
    } catch (error) {
      console.log(error);
      dispatch(setAppLoading(false));
    }

  }

  const setImageCustom = (src) => {
    dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCustom', value: false } })
    if (customImageOrderRef.current == 1) {
      setCustomImage(prev => {
        return {
          ...prev,
          image1: src
        }
      })
    } else {
      setCustomImage(prev => {
        return {
          ...prev,
          image2: src
        }
      })
    }
    console.log(src.replace("data:image/jpeg;base64,", ""))
    onUploadCarImageSub({
      base64: src.replace("data:image/jpeg;base64,", "")
    })
  }

  // console.log("CheckOut Data:", checkOutData);
  return (
    pageLoading == 1 || !outHour ? (
      <ParkingSkeleton />
    ) : (loadingPayment ?
      <div className="htContainer htPaymentSuccess">
        <img src={cardIcon} alt="Card" />
        <div className="htPsTile">결제중입니다</div>
        <div className="htPsDesc">나이스페이먼츠 결제 모듈 영역</div>
        <ThreeDots
          height="60"
          width="60"
          color="#4fa94d"
          ariaLabel="loading"
        />
      </div>
      :
      (completePayment ?
        <div className="htContainer">
          <SubHeader>
            <div
              className={`sub-header-text w-full justify-between`}
            >
              <div className="nl-row">
                <img src={checkIcon} alt="Camera" />
                <span className="ml-5 htBold htColorMain">결제완료</span>
              </div>
              <div>
                <span className="sub-header-btn">출차</span>
              </div>

            </div>
          </SubHeader>

          <div className="htContent htHasButtonBot mn-payment-complete">
            <div className="htSection">
              <h2>주차정보</h2>
              <AppInfoRow label="차량번호" value={checkOutData?.fee?.carNumber} />
              <AppInfoRow label="입차일시" value={datetimeFormat(checkOutData?.fee?.inTime, "ISO", "yyyy-MM-dd HH:mm")} />
              <AppInfoRow label="출차일시" value={datetimeFormat(checkOutData?.fee?.outTime, "ISO", "yyyy-MM-dd HH:mm")} />
              <AppInfoRow label="결제요금" value={numberFormat(checkOutData?.fee?.feeFinal, "원")} />
            </div>
            <div className="htSeparator"></div>

            <div className="htSection">
              <h2>결제정보</h2>
              {/* <AppInfoRow label="결제카드" value="현대카드" valueClass="htBold" /> */}
              <AppInfoRow label="결제카드" value={payData?.track2Data} valueClass="htBold" />
              {/* <div className="htInfoRow">
                <h2>결제금액</h2>
                <h2 className="htIrValue htColorMain">{numberFormat(checkOutData?.fee?.feeFinal, "원")}</h2>
              </div> */}
              <div className="htInfoRow htBold">
                <span className="">결제금액</span>
                <span className="htTotal">{numberFormat(paymentAmount, "원")}</span>
              </div>
              <AppInfoRow label="상품명" value="서울특별시 송파구시설관리공단" />
              <AppInfoRow label="승인번호" value="00712341234" />
              <AppInfoRow label="거래일시" value={getFormattedTime(serverTime, "yyyy-MM-dd HH:mm")} />

              {/* <div className="htInfoRow htBold">
                <span className="">결제금액</span>
                <span className="htTotal">{numberFormat(checkOutData?.fee?.feeFinal, "원")}</span>
              </div> */}
            </div>
            <div className="htSeparator" style={{ marginBottom: '30px' }}></div>
            <button className="htSubmitButton" style={{ fontWeight: "400" }} type="button" onClick={() => { onBillPrint(payData, 'PAY'); }}>결제내역 재발급</button>

            <ButtonBot textYes={`주차상황판`} handleYes={() => {
              navigate("/parking_status")
            }} />

          </div>
        </div>
        :
        (unpaidPayment ?
          <div className="htContainer">
            <SubHeader>
              <div
                className={`sub-header-text w-full justify-between`}
              >
                <div className="nl-row">
                  <img src={note2Icon} alt="Camera" />
                  <span className="ml-5 htBold htColorMain" style={{ color: "#585858", fontSize: "16px", fontWeight: "600" }}>미납처리</span>
                </div>
                <div>
                  <span className="sub-header-btn">출차</span>
                </div>

              </div>
            </SubHeader>

            <div className="htContent htHasButtonBot mn-payment-complete">
              <div className="htSection">
                <h2>주차정보</h2>
                <AppInfoRow label="차량번호" value={selectedSpot?.carNum} />
                <AppInfoRow label="입차일시" value={datetimeFormat(selectedSpot?.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm")} />
                <AppInfoRow label="출차일시" value={datetimeFormat(checkOutTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm")} />
                <AppInfoRow label="미납요금" value={numberFormat(checkOutData?.fee?.feeFinal, "원")} />
              </div>
              <div className="htSeparator" style={{ marginBottom: '79px' }}></div>




              <ButtonBot textYes={`주차상황판`} handleYes={() => navigate("/menu_manager", { replace: true })} />

            </div>
          </div> :
          (
            isOpenCamera ?
              <div className="htVideoContainer">
                <img
                  src={captureClose}
                  alt=""
                  className="htCaptureClose"
                  onClick={() => stopCamera({
                    videoRef: videoRef,
                    setIsOpenCamera: setIsOpenCamera,
                    setShowHeader: (value) => dispatch(setShowHeader(value)),
                  })}
                />
                <video ref={videoRef} autoPlay playsInline className="video" >

                </video>
                <div className="htBackground">
                  <div className="htChild">
                  </div>
                  <div className="htChild2">
                    <div className="htChild">
                    </div>
                    <div className="htCornerBorderDiscount">
                      <div className="htCornerBorderSubDiscount">

                      </div>
                      <div className="htCameraControls">
                        <button
                          type="button"
                          className="htCaptureButton"
                          onClick={() => captureImage({
                            videoRef: videoRef,
                            canvasRef: canvasRef,
                            setIsOpenCamera: setIsOpenCamera,
                            stopCamera: () => stopCamera({
                              videoRef: videoRef,
                              setIsOpenCamera: setIsOpenCamera,
                              setShowHeader: (value) => dispatch(setShowHeader(value)),
                            }),
                            setImage: setDiscountImage,
                          })}
                        >
                          <img src={captureIcon} alt="" />
                        </button>
                      </div>
                    </div>
                    <div className="htChild">
                    </div>
                  </div>

                  <div className="htChild">
                  </div>
                </div>
                <canvas ref={canvasRef} style={{ display: 'none' }} />
              </div>
              :
              isOpenCameraCustom ? (

                <div className={`htVideoContainer`} style={{ overflowY: 'auto' }}>
                  <img
                    src={captureClose}
                    alt=""
                    className="htCaptureClose"
                    onClick={() => stopCamera({
                      videoRef: videoRef,
                      setIsOpenCamera: setIsOpenCameraCustom,
                      setShowHeader: (value) => dispatch(setShowHeader(value)),
                    })} />
                  <video ref={videoRef} autoPlay playsInline className="video" />
                  <div className="htBackground">
                    <div className="nl-square">

                    </div>
                    {/* <div className="htChild" /> */}
                    <div className="htChild2">
                      <div className="htChild" />
                      <div className="htCornerBorder">

                        <div className="htCornerBorderSub" />
                        <div className="htCameraControls">
                          <button
                            type="button"
                            className="htCaptureButton"
                            onClick={() => captureImage({
                              videoRef: videoRef,
                              canvasRef: canvasRef,
                              setIsOpenCamera: setIsOpenCameraCustom,
                              stopCamera: () => stopCamera({
                                videoRef: videoRef,
                                setIsOpenCamera: setIsOpenCameraCustom,
                                setShowHeader: (value) => dispatch(setShowHeader(value)),
                              }),
                              setImage: setImageCustom,
                              _cropWidth: videoRef.current.clientWidth,
                              _cropHeight: videoRef.current.clientHeight,
                            })}
                          >
                            <img src={captureIcon} alt="" />
                          </button>
                        </div>
                      </div>
                      <div className="htChild" />
                    </div>
                    {/* <div className="htChild" /> */}
                  </div>
                  <canvas ref={canvasRef} style={{ display: 'none' }} />
                </div>
              ) : <>
                <AppInfiniteScroll
                  data={[]}
                  hasMore={false}
                  refreshFunction={refreshFunction}
                >
                  <div className="htContainer">
                    <div className="htContent htHasButtonBot">
                      <div className="htSection">
                        <h2>입차정보</h2>
                        <AppInfoRow label="차량번호" value={selectedSpot?.carNum} />
                        <AppInfoRow label="입차일시" value={datetimeFormat(selectedSpot?.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm")} />
                        <AppInfoRow label="주차구분" value={`${selectedSpot?.areaName} (${selectedSpot?.areaTypeName})`} />
                      </div>
                      <div className="htSeparator"></div>

                      <div className="htSection">
                        <h2>주차정보</h2>
                        <AppInfoRow label="주차장명" value={`${user?.parking?.parkingName} (${user?.parkingId})`} />
                        <div className="htInfoRow a-center">
                          <span className={`htIrLabel`}>출차일시</span>
                          <span className={`htIrValue`}>
                            {/* <input
                          className="mn-input nh-input"
                          type="text"
                          placeholder="출차일시"
                          value={checkOutTime}
                          onChange={(e) => setCheckOutTime(e.target.value)}
                          maxLength={16}
                          pattern="\d{4}-\d{2}-\d{2} \d{2}:\d{2}"
                        /> */}
                            {/* <InputMask
                          mask="9999-99-99 99:99"
                          value={checkOutTime}
                          onChange={(e) => setCheckOutTime(e.target.value)}
                        >
                          {(inputProps) => (
                            <input
                              {...inputProps}
                              className="mn-input nh-input"
                              type="text"
                              placeholder="YYYY-MM-DD HH:MM"
                            />
                          )}
                        </InputMask> */}
                            <div className="nl-row">
                              <div className="col-6 mr-5">
                                <select
                                  className="table-select width-80"
                                  value={outHour}
                                  onChange={(e) => setOutHour(e.target.value)}
                                >
                                  {generateHours.map(hour => (
                                    <option key={hour} value={hour}>{hour}</option>
                                  ))}
                                </select>
                              </div>
                              <div className="col-6 ml-5">
                                <select
                                  className="table-select width-80"
                                  value={outMinute}
                                  onChange={(e) => setOutMinute(e.target.value)}
                                >
                                  {generateMinutes.map(minute => (
                                    <option key={minute} value={minute}>{minute}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </span>
                        </div>
                        <AppInfoRow label="주차시간" value={(formatMinutesToTime(checkOutData?.fee?.parkingMinute || 0))} />
                        <AppInfoRow label="주차요금" value={numberFormat(checkOutData?.fee?.feeCalculated || 0, "원")} valueClass="htBold" />
                      </div>
                      <div className="htSeparator"></div>
                      <AppSelect
                        className="htSection mb-0"
                        label="할인적용"
                        value={selectedDiscount}
                        onChange={({ target }) => {
                          const selectedValue = target?.value;

                          if (selectedValue === false) return;


                          if (selectedValue) {
                            setSelectedDiscount(selectedValue || '');
                            discountRef.current = selectedDiscount;
                            const imageArrShow = ['12', '13', '14', '15', '18', '19', '21', '22', '23', '24', '26', '27', '29', '30'];
                            const multipleDiscount = ['10', '30'];
                            let currentDiscount = checkOutData?.fee?.discountDetails || [];

                            if (multipleDiscount.includes(selectedValue) && isIdInArray(currentDiscount, selectedValue)) {
                              return false;
                            }
                            if (imageArrShow.includes(selectedValue)) {
                              dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupDiscount', value: true } });
                            } else {
                              onApplyOrCancelDiscount("APPLY", selectedValue);
                            }
                          } else {
                            dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveAllDiscount', value: true } })
                          }
                        }}
                        options={
                          discountList.length > 0
                            ? discountList
                            : [{ label: "할인없음", value: false }]
                        }
                      />


                      <div className="htSeparator"></div>
                      <div className="htSection">
                        <h2>결제요금</h2>
                        {checkOutData?.fee?.carType == "FREE" && <AppInfoRow label="차량 종류" value="비용 없음" valueClass="htBold" />}
                        {checkOutData?.fee?.carType == "REGISTRATION" && <AppInfoRow label="차량 종류" value="정기권 등록" valueClass="htBold" />}
                        <AppInfoRow label="주차요금" value={numberFormat(checkOutData?.fee?.feeCalculated || 0, "원")} valueClass="htBold" />

                        {/*<AppInfoRow label="할인요금" value={""} valueClass="htBold"/> */}
                        {
                          checkOutData?.fee?.discountDetails?.map((item, index) => {
                            var imageArrShow = ['12', '13', '14', '15', '18', '19', '21', '22', '23', '24', '26', '27', '29', '30'];
                            const isClickable = imageArrShow.includes(String(item.id));
                            return (
                              <div
                                key={index}
                                className="htInfoRow"
                              >
                                <span className={`htIrLabel nl-row`}>
                                  <span
                                    onClick={() => {
                                      if (isClickable) {
                                        setDiscountImageRemove(`${getApiBaseUrl()}facility/uploads?filename=${selectedSpot?.entryId}_discount_id${item.id}.jpeg&applyDate=${item.applyTime.slice(0, 8)}&parkingId=${selectedSpot.parkingId}&data=${Math.random()}`);
                                        setSelectedDiscountRemove(item.id);
                                        setIsPopupImageFullOpen(true)
                                      } else {
                                        setSelectedDiscountRemove(item.id);
                                      }
                                    }}
                                  >{item.name}</span>
                                  <img
                                    src={removeDiscountIcon}
                                    onClick={() => {
                                      if (isClickable) {
                                        setDiscountImageRemove(`${getApiBaseUrl()}facility/uploads?filename=${selectedSpot?.entryId}_discount_id${item.id}.jpeg&applyDate=${item.applyTime.slice(0, 8)}&parkingId=${selectedSpot.parkingId}&data=${Math.random()}`);
                                        setSelectedDiscountRemove(item.id);
                                        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: true } });
                                      } else {
                                        setSelectedDiscountRemove(item.id);
                                        dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: true } });
                                      }
                                    }}
                                    alt="remove"
                                    className="pl-10 pr-20"
                                  />
                                </span>
                                <span className={`htIrValue`}>{item.id == '10' ? "-60 분" : numberFormat(-Math.abs(item.fee), "원")}</span>
                              </div>

                            )
                          })
                        }

                        <div className="htInfoRow htBold">
                          <span className="">결제금액</span>
                          <span className="htTotal">{numberFormat(checkOutData?.fee?.feeFinal || 0)}원</span>
                        </div>
                        <div className="htInfoRow">
                          <span className=""></span>
                          <span className="">십원 금액 절사</span>
                        </div>
                      </div>
                      <div className="htSeparator">
                        <div className="htSection">
                          <h2>추가사진</h2>
                          <div className="nl-row gap-2">
                            <div className="htCarImage htCarImage2"
                              onClick={() => {
                                customImageOrderRef.current = 1;
                                imageCaptureTypeRef.current = "CUSTOM";
                                customImage?.image1 ? setIsPopupCustomImageFullOpen(true) : dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCustom', value: true } })
                                // customImage?.image1 ? setIsPopupCustomImageFullOpen(true) : onSelectImage(1)
                              }}
                              style={customImage?.image1 ? null : { border: '2px dashed #D2D2D2', backgroundColor: "#F8F8F8", overflow: 'hidden' }}
                            >

                              {customImage?.image1 ?
                                <>
                                  <img
                                    src={removeDiscountIcon}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      customImageRemoveRef.current = 1;
                                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveCustomImage', value: true } })
                                    }}
                                    alt="remove"
                                    className="htRemoveCustom"
                                  />
                                  <div className="nl-image-license-plate htBorder">
                                    <img src={encodeURI(customImage?.image1)}
                                      alt="Uploaded"
                                      onError={handleImageError} />
                                  </div>
                                </>
                                :
                                <div className="nl-text-add">
                                  <span className="htAddIcon">
                                    <img src={plusIcon} alt="Add" />
                                  </span>
                                </div>}
                            </div>
                            <div className="htCarImage htCarImage2"
                              onClick={() => {
                                customImageOrderRef.current = 2;
                                imageCaptureTypeRef.current = "CUSTOM";
                                customImage?.image2 ? setIsPopupCustomImageFullOpen(true) : dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCustom', value: true } })
                                // customImage?.image2 ? setIsPopupCustomImageFullOpen(true) : onSelectImage(2)
                              }} style={customImage?.image2 ? null : { border: '2px dashed #D2D2D2', backgroundColor: "#F8F8F8", overflow: 'hidden' }}
                            >
                              {customImage?.image2 ?
                                <>
                                  <img
                                    src={removeDiscountIcon}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      customImageRemoveRef.current = 2;
                                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveCustomImage', value: true } })
                                    }}
                                    alt="remove"
                                    className="htRemoveCustom"
                                  />
                                  <div className="nl-image-license-plate htBorder">
                                    <img src={encodeURI(customImage?.image2)}
                                      alt="Uploaded"
                                      onError={handleImageError} />
                                  </div>
                                </>
                                :
                                <div className="nl-text-add">
                                  <span className="htAddIcon">
                                    <img src={plusIcon} alt="Add" />
                                  </span>
                                </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="htSeparator"></div>
                      <div className="htSection">
                        <h2>결제할 금액</h2>
                        <div className="htStMoney mnStMoney">
                          <input
                            className="htStMoney mn-input"
                            type="text"
                            placeholder="금액을 입력해주세요"
                            value={
                              paymentAmount || paymentAmount == 0
                                ? numberFormat(paymentAmount)
                                : numberFormat(checkOutData?.fee?.feeFinal) || ''
                            }
                            onChange={(e) => {
                              let input = e.target.value;

                              if (input === '') {
                                setPaymentAmount('0');
                              } else {
                                setPaymentAmount(input.replace(/[^0-9]/g, ''));
                              }
                            }}
                          />
                        </div>
                      </div>



                    </div>

                  </div>
                </AppInfiniteScroll>
                <ButtonBot
                  textYes={paymentAmount > 0 ? `결제` : `출차`}
                  style={{ position: 'sticky' }}
                  handleYes={() => {
                    console.log(checkOutData.fee.discountDetails)
                    // const regex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;
                    // if (!regex.test(checkOutTime)) {
                    //   dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupErrorTime', value: true } });
                    //   return false;
                    // }
                    // const date = new Date(checkOutTime);
                    // if (isNaN(date)) {
                    //   dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupErrorTime', value: true } });
                    //   return false;
                    // }
                    const checkOutDate = serverTime?.set({
                      hour: parseInt(outHour),
                      minute: parseInt(outMinute),
                      second: 0,
                    }).toISO();

                    const inTime = datetimeFormat(selectedSpot?.inTime, "yyyyMMddHHmmss", "yyyy-MM-dd HH:mm");
                    const dateInTime = new Date(inTime)
                    console.log("CheckOut Date:", checkOutDate);
                    console.log("In Time:", dateInTime);
                    console.log(checkOutDate < dateInTime);
                    if (checkOutData?.fee?.parkingMinute < 0) {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCompareTime', value: true } });
                      return false;
                    } else if (checkOutData?.fee?.parkingMinute >= 0 && checkOutData?.fee?.parkingMinute <= 5) {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupTurnOut', value: true } });
                      return false;
                    } else if (paymentAmount == 0) {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupZeroFee', value: true } });
                      return false;
                    }
                    dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPay', value: true } });
                    // if (paymentAmount > 0) {
                    //   setShowPopupPay(true);
                    // }
                  }}
                />

                {isPopupFullImageOpen && (
                  <ImageViewPopup
                    imageSrc={discountImageRemove ? discountImageRemove : cameraIcon}
                    onClose={() => {
                      setIsPopupImageFullOpen(false);
                      setZoomLevel(1);
                    }}
                    zoomLevel={zoomLevel}
                    setZoomLevel={setZoomLevel}
                    onError={(e) => handleImageError(e)}
                  />
                )}

                {isPopupFullCustomImageOpen && (
                  <ImageViewPopup
                    imageSrc={customImageOrderRef.current == 1 ? encodeURI(customImage.image1) : encodeURI(customImage.image2)}
                    onClose={() => {
                      setIsPopupCustomImageFullOpen(false);
                      setZoomLevel(1);
                    }}
                    zoomLevel={zoomLevel}
                    setZoomLevel={setZoomLevel}
                    onError={(e) => handleImageError(e)}
                  />
                )}

                {popupState.showPopupDiscount && (
                  <Popup
                    title="할인적용 사진 촬영"
                    handleYes={() => onApplyOrCancelDiscount("APPLY", selectedDiscount)}
                    textYes="저장하기"
                    textNo="취소"

                    onClose={() => {
                      setSelectedDiscount(discountRef.current || "");
                      setDiscountImage(null);
                      setShowErrorImg(false);
                    }}
                    setVisible={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupDiscount', value: false } })}
                  >
                    <div className="htPpCamera">
                      <div className="htPpCamera_tit">{discountList.find(item => item.discountId == selectedDiscount)?.label}</div>
                      <div className="htPpCamera__btn " onClick={() => setIsOpenCamera(true)} style={discountImage ? { padding: 0, marginBottom: 15 } : null}>
                        <img src={discountImage ? discountImage : cameraIcon} alt="camera" style={discountImage ? { width: 256, height: 256, objectFit: 'cover' } : null} />
                        {!discountImage && <span className="htBold ml-5">사진 촬영</span>}
                      </div>
                      <div className={`mt-5 ${showErrorImg ? '' : 'htHide'}`}><span className="htError">사진을 찍어주세요.</span></div>
                    </div>

                  </Popup>
                )}
                {popupState.showPopupNice && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupNice', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>NICEPAY 앱을 설치하고 다시 시도해주세요!</div>
                    </div>

                  </Popup>
                )}
                {popupState.showPopupRemoveDiscount && (
                  <Popup
                    title="할인적용 삭제"
                    handleYes={() => onApplyOrCancelDiscount("CANCEL", selectedDiscountRemove)}
                    textYes="예"
                    textNo="아니오"
                    onClose={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: false } })
                      setDiscountImage(null);
                    }}
                    handleNo={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: false } })
                      setDiscountImage(null);
                    }}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscount', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>할인정보를 삭제할까요?</div>
                      {discountImageRemove && <div className="htPpCamera__btn nl-row j-center mt-10">
                        <img src={discountImageRemove ? discountImageRemove : cameraIcon} onError={(e) => handleImageError(e)} alt="camera" style={discountImageRemove ? { width: 256, height: 256, objectFit: 'cover' } : null} />
                        {!discountImageRemove && <span className="htBold ml-5">사진 촬영</span>}
                      </div>}
                    </div>

                  </Popup>
                )}
                {popupState.showPopupRemoveDiscountNoImage && (
                  <Popup
                    title="할인적용 삭제"
                    handleYes={() => onApplyOrCancelDiscount("CANCEL", selectedDiscountRemove)}
                    textYes="예"
                    textNo="아니오"
                    onClose={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: false } })
                      setDiscountImage(null);
                    }}
                    handleNo={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: false } })
                      setDiscountImage(null);
                    }}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveDiscountNoImage', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>할인정보를 삭제할까요?</div>
                    </div>

                  </Popup>
                )}
                {popupState.showPopupPay && (
                  <Popup
                    title="결제 확인"
                    handleYes={onPayment}
                    textYes="예"
                    textNo="아니오"
                    handleNo={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPay', value: false } });
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupUnpaid', value: true } });
                    }}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPay', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>결제를 진행하시겠습니까?</div>
                      <div>(아니오 클릭시 미납처리됨)</div>
                    </div>


                  </Popup>
                )}
                {popupState.showPopupUnpaid && (
                  <Popup
                    title="알림"
                    handleYes={() => {
                      onUnpaid(true)
                    }
                    }
                    textYes="예"
                    textNo="아니오"
                    handleNo={() => {
                      onUnpaid()
                    }}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupUnpaid', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>미납처리를 진행합니다.</div>
                      <div>미납증을 발급 하시겠습니까?</div>
                    </div>
                  </Popup>
                )}

                {popupState.showPopupFeeAlert && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showFeeAlert', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showFeeAlert', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>최소 {numberFormat(checkOutData?.fee?.feeFinal || 0)}원 이상 결제하셔야 합니다.</div>
                    </div>

                  </Popup>
                )}

                {popupState.showPopupPayError && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupPayError', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>결제 중 오류가 발생했습니다. 다시 시도해주세요!</div>
                    </div>


                  </Popup>
                )}
                {popupState.showPopupError && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupError', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>오류가 발생했습니다. 다시 시도해 주세요.</div>
                    </div>


                  </Popup>
                )}
                {popupState.showPopupErrorTime && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupErrorTime', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupErrorTime', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>유효한 날짜를 입력하세요.</div>
                    </div>


                  </Popup>
                )}
                {popupState.showPopupParkingOperateTime && !appLoading && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupParkingOperateTime', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupParkingOperateTime', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>주차장 운영 시간이 변경되었습니다. 다시 시도해 주세요.</div>
                    </div>


                  </Popup>
                )}
                {popupState.showPopupCompareTime && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCompareTime', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCompareTime', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>출차일시가 입차일시보다 작을 수 없습니다.</div>
                    </div>

                  </Popup>
                )}
                {popupState.showPopupMissingTid && (
                  <Popup
                    title="결제"
                    handleYes={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: false } })}
                    textYes="예"
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupMissingTid', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>주차장에 대한 결제 식별자(TID) 정보가 없습니다.</div>
                    </div>


                  </Popup>
                )}

                {popupState.showPopupTurnOut && (
                  <Popup
                    title="알림"
                    handleYes={() => onFreeFee(true)}
                    textYes="예"
                    textNo="아니오"
                    handleNo={() => onFreeFee(false)}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupTurnOut', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>회차 차량의 출차를 진행합니다.</div>
                      <div>출차증을 발급 하시겠습니까?</div>
                    </div>

                  </Popup>
                )}
                {popupState.showPopupZeroFee && (
                  <Popup
                    title="알림"
                    handleYes={() => onFreeFee(true)}
                    textYes="예"
                    textNo="아니오"
                    handleNo={() => {
                      onFreeFee(false);
                    }}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupZeroFee', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>이 차량의 출차를 진행합니다.</div>
                      <div>출차증을 발급 하시겠습니까?</div>
                    </div>

                  </Popup>
                )}

                {popupState.showPopupRemoveCustomImage && (
                  <Popup
                    title="알림"
                    handleYes={handleRemoveCarImageSub}
                    textYes="예"
                    textNo="아니오"
                    handleNo={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveCustomImage', value: false } })}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveCustomImage', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>정말 삭제하시겠습니까?</div>
                    </div>
                  </Popup>
                )}

                {popupState.showPopupCustom && (
                  <Popup
                    title="추가사진"
                    handleYes={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCustom', value: false } });
                      customImageOrderRef.current == 1 ? onSelectImage(1) : onSelectImage(2);
                    }}
                    textYes="갤러리 열기"
                    textNo="취소"

                    onClose={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCustom', value: false } })
                    }}
                    setVisible={() => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupCustom', value: false } })}
                  >
                    <div className="htPpCamera">
                      <div className="htPpCamera__btn " onClick={() => setIsOpenCameraCustom(true)} style={discountImage ? { padding: 0, marginBottom: 15 } : null}>
                        <img src={cameraIcon} alt="camera" />
                        {!discountImage && <span className="htBold ml-5">사진 촬영</span>}
                      </div>
                      <div className={`mt-5 ${showErrorImg ? '' : 'htHide'}`}><span className="htError">사진을 찍어주세요.</span></div>
                    </div>

                  </Popup>
                )}

                {popupState.showPopupRemoveAllDiscount && (
                  <Popup
                    title="할인적용 삭제"
                    handleYes={() => onCancelAllDiscount("CANCEL")}
                    textYes="예"
                    textNo="아니오"
                    onClose={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveAllDiscount', value: false } })
                    }}
                    handleNo={() => {
                      dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveAllDiscount', value: false } })
                    }}
                    setVisible={(value) => dispatchPopup({ type: 'SET_POPUP', payload: { key: 'showPopupRemoveAllDiscount', value: value } })}
                  >
                    <div className="nl-row f-column">
                      <div>모든 할인 정보를 삭제할까요?</div>
                    </div>

                  </Popup>
                )}
              </>
          )
        )
      )
    ));
}

export default ParkingPayment;


function ParkingSkeleton() {
  return (
    <div className="htSection" style={{ padding: '16px' }}>
      <h2>입차정보</h2>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={80} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={120} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>

      <h2 style={{ marginTop: 24 }}>주차정보</h2>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={140} height={20} /></div>
      <div className="nl-row j-between"><Skeleton width={100} height={20} /> <Skeleton width={60} height={20} /></div>
      <h2 style={{ marginTop: 24 }}>할인적용</h2>
      <div><Skeleton height={40} width="100%" /></div>
      {/* <div><Skeleton width={100} height={20}/></div> */}

      <h2 style={{ marginTop: 24 }}>결제금액</h2>
      <div><Skeleton width={150} height={32} /></div>
      <div><Skeleton width={80} height={32} /></div>

      <h2 style={{ marginTop: 24 }}>결제할 금액</h2>
      <div><Skeleton width="100%" height={40} /></div>
    </div>
  );
}

